import React, { useState, useEffect, useRef } from 'react';
import './InputPadrao.css';
import '../CampoObrigatorio/CampoObrigatorio.css';
import CampoObrigatorio from '../CampoObrigatorio/CampoObrigatorio';
import { MdClose } from 'react-icons/md';
import FormatacaoUtils, { TipoFormatacao } from '../../utils/FormatacaoUtils';
import { validarPermissoes } from '../../utils/PermissaoUtils';

const TipoInput = {
  TEXT: 'text',
  PASSWORD: 'password',
  EMAIL: 'email',
  NUMBER: 'number',
  DOCUMENTO: 'documento', 
};

// Enum para os lados
const Lados = {
  NENHUM: 'nenhum',
  ESQUERDA: 'esquerda',
  DIREITA: 'direita',
  AMBOS: 'ambos'
};

const InputPadrao = ({ 
  id, 
  name,
  label, 
  value, 
  onChange, 
  placeholder, 
  required = false,
  type = TipoInput.TEXT, 
  disabled = false,
  icone = null,
  erroMensagem = "",
  tipoFormatador = null,
  ladoSemBorda = Lados.NENHUM,  
  ladoSemBorderRadius = Lados.NENHUM,  
  permissao,
  permiteEspacos = true,  // controla se espaços são permitidos
  maxLength = 220,  // limite de caracteres personalizável
  style = {},  // adicionar suporte para estilos customizados
  suffix = null
}) => {
    const [valorInput, setValorInput] = useState("");
    const [valorPuro, setValorPuro] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);
    const inputName = name || id;
    const [erroMaxLength, setErroMaxLength] = useState(false);

    const getTipoFormatacao = () => {
      if (tipoFormatador) return tipoFormatador;
      
      if (type === TipoInput.DOCUMENTO) return TipoFormatacao.DOCUMENTO;
      return null;
    };
    
    useEffect(() => {
      if (value !== undefined) {
        const formatador = getTipoFormatacao();
        let novoValorPuro = formatador && typeof value === 'string' 
          ? value.replace(/\D/g, "") 
          : value;
        
        // Limitar tamanho para o tipo DOCUMENTO no useEffect também
        if (formatador === TipoFormatacao.DOCUMENTO && typeof novoValorPuro === 'string' && novoValorPuro.length > 14) {
          novoValorPuro = novoValorPuro.substring(0, 14);
        }
        
        if (novoValorPuro !== valorPuro) {
          setValorPuro(novoValorPuro);
          
          if (formatador && typeof value === 'string') {
            const valorFormatado = FormatacaoUtils.formatarPorTipo(formatador, novoValorPuro);
            setValorInput(valorFormatado);
            
            if (value.replace(/\D/g, "").length > novoValorPuro.length && onChange) {
              onChange({ target: { value: novoValorPuro, id, name: inputName } });
            }
          } else {
            setValorInput(value || "");
          }
        }
      }
    }, [value, tipoFormatador, type, onChange, id, inputName, valorPuro]);
      const handleInputChange = (e) => {
      let valor = e.target.value;
      
      // sanitiza espaços caso não permitido
      if (!permiteEspacos) {
        valor = valor.replace(/\s/g, '');
      }
      if (valor === undefined) valor = "";
      
      const formatador = getTipoFormatacao();
      const valorSemFormatacao = formatador ? valor.replace(/\D/g, "") : valor;
      
      // Limitar tamanho para o tipo DOCUMENTO (CPF 11 dígitos ou CNPJ 14 dígitos)
      let valorLimitado = valorSemFormatacao;
      if (type === TipoInput.DOCUMENTO && valorSemFormatacao.length > 14) {
        valorLimitado = valorSemFormatacao.substring(0, 14);
      }
      
      setValorPuro(valorLimitado);
      
      let valorExibido = valor;
      if (formatador) {
        valorExibido = FormatacaoUtils.formatarPorTipo(formatador, valorLimitado);
      }
      
      // Limitar valor exibido pelo maxLength
      if (valorExibido.length > maxLength) {
        valorExibido = valorExibido.substring(0, maxLength);
      }
      
      setValorInput(valorExibido);
      
      // Verifica limite de caracteres
      setErroMaxLength(valorExibido.length >= maxLength);

      if (onChange) {
        const novoEvento = {
          ...e,
          target: {
            ...e.target,
            value: valorLimitado, 
            id: id,
            name: inputName
          }
        };
        onChange(novoEvento);
      }
    };

    const handleFocus = () => {
      setIsFocused(true);
    };

    const handleBlur = () => {
      setIsFocused(false);
    };

    const handleClear = () => {
      setValorInput("");
      setValorPuro("");
      if (onChange) {
        onChange({ target: { value: "", id, name: inputName } });
      }
      inputRef.current.focus();
    };

    const hasPermissao = permissao ? validarPermissoes(permissao) : true;
    if (!hasPermissao) return null;

    return (
      <div className="input-container" style={{ position: 'relative', ...style }}>
        <div
          className={[
            'input-wrapper',
            valorInput?.length > 0 && 'preenchido',
            erroMensagem && 'erro',
            isFocused && 'focused',
               suffix && 'com-suffix',
            ladoSemBorda !== Lados.NENHUM && `sem-borda-${ladoSemBorda}`,
            ladoSemBorderRadius !== Lados.NENHUM && `sem-border-radius-${ladoSemBorderRadius}`,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <input
            id={id}
            name={inputName}
            ref={inputRef}
            type={type}
            value={valorInput}
            onChange={handleInputChange}
            onKeyPress={e => !permiteEspacos && e.key === ' ' && e.preventDefault()}
             onFocus={handleFocus}
             onBlur={handleBlur}
             placeholder={placeholder}
               className={`input-padrao ${icone ? 'com-icone' : ''} ${suffix ? 'com-suffix' : ''}`}
             disabled={disabled}
             required={required}
             maxLength={maxLength}
             style={style}
          />

          {suffix && (
            <span className="input-suffix">
              {suffix}
            </span>
          )}
  
          {label && (
            <div className={`input-label-container${icone ? ' com-icone' : ''}`}>
              {icone && (
                <div className={`input-icone${erroMensagem ? ' erro' : ''}`}>
                  {icone}
                </div>
              )}
              <label htmlFor={id} className="input-label">
                {label}
              </label>
              {required && <span className="required-spacer"><CampoObrigatorio /></span>}
            </div>
          )}

          {valorInput?.length > 0 && !disabled && !suffix && (
          <div className="limpar-input" onClick={handleClear} title="Limpar">
              <MdClose />
          </div>
)}
        </div>
        <div className={`input-erro-msg ${!erroMensagem && !erroMaxLength ? 'hidden' : ''}`}>
          {erroMaxLength
            ? `Limite de ${maxLength} caracteres alcançado`
            : erroMensagem || " "
          }
        </div>
      </div>
    );
}

InputPadrao.TipoInput = TipoInput;
InputPadrao.Lados = Lados;  
InputPadrao.LadoSemBorda = Lados;
 
export default InputPadrao;